import { Slider } from "@/components/ui/slider";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export interface ThresholdValue {
  candidate_threshold: number;
  verify_threshold: number;
  confirm_threshold: number;
  cooldown_seconds: number;
  max_matches_per_day: number | null;
}

interface Props {
  value: ThresholdValue;
  onChange: (patch: Partial<ThresholdValue>) => void;
  disabled?: boolean;
}

export function ThresholdSliders({ value, onChange, disabled }: Props) {
  const slot = (
    label: string,
    field: keyof ThresholdValue,
    min: number,
    max: number,
    step: number,
  ) => (
    <div>
      <div className="flex items-center justify-between mb-1">
        <Label className="text-xs uppercase tracking-wide text-muted-foreground">
          {label}
        </Label>
        <span className="text-xs font-mono">{(value[field] as number)?.toFixed(2)}</span>
      </div>
      <Slider
        value={[value[field] as number]}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        onValueChange={(v) => onChange({ [field]: v[0] } as Partial<ThresholdValue>)}
      />
    </div>
  );

  return (
    <div className="space-y-3">
      {slot("Candidate threshold", "candidate_threshold", 0, 1, 0.01)}
      {slot("Verify threshold", "verify_threshold", 0, 1, 0.01)}
      {slot("Confirm threshold", "confirm_threshold", 0, 1, 0.01)}
      <div>
        <Label className="text-xs uppercase tracking-wide text-muted-foreground">
          Cooldown (seconds)
        </Label>
        <Input
          type="number"
          min={0}
          max={86400}
          step={60}
          value={value.cooldown_seconds}
          disabled={disabled}
          onChange={(e) =>
            onChange({ cooldown_seconds: Math.max(0, Number(e.target.value) || 0) })
          }
        />
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wide text-muted-foreground">
          Max matches per day (blank = no cap)
        </Label>
        <Input
          type="number"
          min={1}
          max={500}
          value={value.max_matches_per_day ?? ""}
          disabled={disabled}
          onChange={(e) => {
            const n = e.target.value === "" ? null : Number(e.target.value);
            onChange({ max_matches_per_day: n });
          }}
        />
      </div>
    </div>
  );
}
